export class AuthConfig {
    constructor(
        public identityPoolId: string,
        public region: string,
        public userPoolId: string,
        public userPoolWebClientId: string,
        public authenticationFlowType: string = 'USER_SRP_AUTH'
    ) {}
}